import { setDefaultOptions } from "date-fns";
import { enUS, es } from "date-fns/locale";
import i18n from "i18next";

function applyLocale(lng: string) {
  setDefaultOptions({ locale: lng.startsWith("es") ? es : enUS });
}

applyLocale(i18n.language || "en");
i18n.on("languageChanged", applyLocale);
